import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "card"
};
var _hoisted_2 = {
  class: "media"
};
var _hoisted_3 = {
  class: "video-wrap"
};
var _hoisted_4 = ["poster", "src"];
var _hoisted_5 = {
  class: "user-section"
};
var _hoisted_6 = {
  class: "user-row"
};
var _hoisted_7 = {
  class: "avatar"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 1,
  class: "avatar-fallback"
};
var _hoisted_10 = {
  class: "user-info"
};
var _hoisted_11 = {
  class: "user-name"
};
var _hoisted_12 = {
  class: "follow-pill"
};
var _hoisted_13 = {
  class: "user-sub"
};
var _hoisted_14 = {
  class: "desc"
};
var _hoisted_15 = {
  class: "desc-text"
};
var _hoisted_16 = {
  class: "stats-row"
};
var _hoisted_17 = {
  class: "stat"
};
var _hoisted_18 = {
  class: "stat-num"
};
var _hoisted_19 = {
  class: "stat"
};
var _hoisted_20 = {
  class: "stat-num"
};
var _hoisted_21 = {
  class: "stat"
};
var _hoisted_22 = {
  class: "stat-num"
};
var _hoisted_23 = {
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_WechatOpenLaunchApp = _resolveComponent("WechatOpenLaunchApp");
  var _component_van_loading = _resolveComponent("van-loading");
  var _component_van_overlay = _resolveComponent("van-overlay");
  var _component_van_action_sheet = _resolveComponent("van-action-sheet");
  var _component_CirclePostOpenAppConfirm = _resolveComponent("CirclePostOpenAppConfirm");
  return _openBlock(), _createElementBlock("div", {
    class: "post-detail",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.onOpenInApp && _ctx.onOpenInApp.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("video", {
    class: "video",
    poster: $options.coverUrl,
    src: $options.videoUrl,
    controls: false,
    playsinline: "",
    "webkit-playsinline": "",
    "x5-playsinline": "",
    preload: "metadata"
  }, null, 8, _hoisted_4), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "play-overlay",
    "aria-hidden": "true"
  }, [_createElementVNode("svg", {
    class: "play-icon",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("path", {
    d: "M15 12 L15 36 L34 24 Z",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "5",
    "stroke-linejoin": "round",
    "stroke-linecap": "round",
    "paint-order": "stroke fill"
  })])], -1))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$options.avatarUrl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "avatar-img",
    src: $options.avatarUrl,
    alt: ""
  }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("div", _hoisted_9, "U"))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode(_toDisplayString($options.userName) + " ", 1), _createElementVNode("div", _hoisted_12, _toDisplayString($options.followedText), 1)]), _createElementVNode("div", _hoisted_13, _toDisplayString($options.userSub), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString($options.descText), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_van_icon, {
    name: "like-o"
  }), _createElementVNode("span", _hoisted_18, _toDisplayString($options.likeCount), 1)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_icon, {
    name: "star-o"
  }), _createElementVNode("span", _hoisted_20, _toDisplayString($options.favoriteCount), 1)]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_icon, {
    name: "chat-o"
  }), _createElementVNode("span", _hoisted_22, _toDisplayString($options.commentCount), 1)])])])]), _createElementVNode("div", {
    class: "bottom",
    onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
  }, [_ctx.useWechatOpenLaunchApp ? (_openBlock(), _createBlock(_component_WechatOpenLaunchApp, {
    key: 0,
    "app-id": _ctx.wechatOpenLaunchAppId,
    extinfo: $options.wxCirclePostExtinfo,
    "button-text": "App内打开",
    variant: "pill"
  }, null, 8, ["app-id", "extinfo"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "open-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onOpenInApp && _ctx.onOpenInApp.apply(_ctx, arguments);
    })
  }, "App内打开"))]), _createVNode(_component_van_overlay, {
    show: $data.loading,
    onClick: _ctx.onOpenInApp
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_23, [_createVNode(_component_van_loading, {
        size: "24",
        color: "#fff"
      })])];
    }),
    _: 1
  }, 8, ["show", "onClick"]), _createVNode(_component_van_action_sheet, {
    show: $data.showActions,
    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
      return $data.showActions = $event;
    }),
    actions: $options.actionSheetActions,
    "cancel-text": "取消",
    "close-on-click-action": "",
    onSelect: $options.onActionSelect
  }, null, 8, ["show", "actions", "onSelect"]), _createVNode(_component_CirclePostOpenAppConfirm, {
    show: _ctx.showAppLeaveConfirm,
    "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.showAppLeaveConfirm = $event;
    }),
    onConfirm: _ctx.confirmOpenInApp
  }, null, 8, ["show", "onConfirm"])]);
}